export const missionEditTabPath = (missionId: string, tab: string) =>
  `/main/dashboard/mission/edit/${missionId}/${tab}`;

export const missionRecommendationsPath = (missionId: string) =>
  `/main/dashboard/mission/${missionId}/recommendations`;

export const missionCompletePath = (missionId: string, tab: string, reason: string) =>
  `${missionEditTabPath(missionId, tab)}/complete-mission/${reason}`;
